'use strict';

var styled = require('styled-components');
var getThemeByProps = require('@userzoomlibraries/toolkit-theme-manager/get-theme-by-props');
var React = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var Portal = require('@userzoomlibraries/toolkit-portal');
var isDefinedAndNotNull = require('@userzoomlibraries/toolkit-js-utils/is-defined-and-not-null');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');
var isNumber = require('@userzoomlibraries/toolkit-js-utils/is-number');
var getSafeHtmlElement = require('@userzoomlibraries/toolkit-js-utils/get-safe-html-element');
var useDataAttributes = require('@userzoomlibraries/toolkit-react-utils/use-data-attributes');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var getThemeByProps__default = /*#__PURE__*/_interopDefaultCompat(getThemeByProps);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var Portal__default = /*#__PURE__*/_interopDefaultCompat(Portal);
var isDefinedAndNotNull__default = /*#__PURE__*/_interopDefaultCompat(isDefinedAndNotNull);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);
var isNumber__default = /*#__PURE__*/_interopDefaultCompat(isNumber);
var getSafeHtmlElement__default = /*#__PURE__*/_interopDefaultCompat(getSafeHtmlElement);
var useDataAttributes__default = /*#__PURE__*/_interopDefaultCompat(useDataAttributes);

var _excluded = ["className", "appendTo", "children", "top", "left", "onAnimationEnd", "onTransitionEnd"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FloatingElement$1 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
      appendTo = _ref.appendTo,
      children = _ref.children,
      top = _ref.top,
      left = _ref.left,
      onAnimationEnd = _ref.onAnimationEnd,
      onTransitionEnd = _ref.onTransitionEnd,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes__default["default"](rest, {
    excludedAttributes: ['data-is-floating-element']
  });
  var portalRef = React.useRef();
  React.useImperativeHandle(ref, function () {
    return Portal.getPortalDOMByRef(portalRef);
  });
  React.useEffect(function () {
    if (portalRef.current) {
      var portalElement = Portal.getPortalDOMByRef(portalRef);

      if (isDefinedAndNotNull__default["default"](top)) {
        var topToApply = isNumber__default["default"](top) ? "".concat(top, "px") : top;
        portalElement.style.top = topToApply;
      }

      if (isDefinedAndNotNull__default["default"](left)) {
        var leftToApply = isNumber__default["default"](left) ? "".concat(left, "px") : left;
        portalElement.style.left = leftToApply;
      }
    }
  }, [top, left]);
  return /*#__PURE__*/jsxRuntime.jsx(Portal__default["default"], _objectSpread(_objectSpread({
    ref: portalRef,
    appendTo: appendTo,
    className: "gz-floating-element ".concat(className),
    onAnimationEnd: onAnimationEnd,
    onTransitionEnd: onTransitionEnd,
    "data-is-floating-element": "true" // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: children
  }));
});
FloatingElement$1.COMPONENT_ID = 'Gearz.FloatingElement';
FloatingElement$1.displayName = FloatingElement$1.COMPONENT_ID;
FloatingElement$1.propTypes = {
  className: PropTypes__default["default"].stringWithDescription('Custom class to be applied.'),
  appendTo: PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].string, PropTypes__default["default"].instanceOf(getSafeHtmlElement__default["default"]())], 'Destination element to append the floating element.'),
  children: PropTypes__default["default"].nodeWithDescription('Content of the floating element.'),
  top: PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].number, PropTypes__default["default"].string], 'Top position of the floating element.'),
  left: PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].number, PropTypes__default["default"].string], 'Left position of the floating element.'),
  onAnimationEnd: PropTypes__default["default"].funcWithDescription('Callback called when opening/closing animation ends.'),
  onTransitionEnd: PropTypes__default["default"].funcWithDescription('Callback cllaed when a transition ends.')
};
FloatingElement$1.defaultProps = {
  className: '',
  appendTo: null,
  children: null,
  top: null,
  left: null,
  onAnimationEnd: noop__default["default"],
  onTransitionEnd: noop__default["default"]
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var FloatingElement = styled__default["default"](FloatingElement$1).withConfig({
  componentId: "gz-floating-element-1673535288545__sc-19efe4y-0"
})(["left:0;position:absolute;top:0;white-space:nowrap;z-index:100;", ""], function (props) {
  return getThemeByProps__default["default"]({
    componentId: FloatingElement$1.COMPONENT_ID,
    props: props
  });
});
FloatingElement.displayName = FloatingElement$1.displayName;
FloatingElement.propTypes = FloatingElement$1.propTypes;
FloatingElement.defaultProps = FloatingElement$1.defaultProps;

exports.FloatingElement = FloatingElement;
